import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface DrawerState {
  open: boolean | null;
}

const initialState: DrawerState = {
  open: null,
};

export const sideBarSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
  },
});

export const { setOpen } = sideBarSlice.actions;

export default sideBarSlice.reducer;
